import GrowingIcon from "../../../components/Icon/GrowingIcon";
import HotIcon from "../../../components/Icon/HotIcon";
import InterestingIcon from "../../../components/Icon/InterestingIcon";
import Process5Icon from "../../../components/Icon/Process5Icon";
import StartedIcon from "../../../components/Icon/StartedIcon";
import VeryHotIcon from "../../../components/Icon/VeryHotIcon";
import { useTranslation } from "react-i18next";

const GroupCardProcess = ({ process }: any) => {
  const { t } = useTranslation();
  return (
    <>
      <div
        style={{
          color: "#9aa9b3",
          textAlign: "center",
          fontSize: "11px",
          fontStyle: "normal",
          fontWeight: 600,
          lineHeight: "120%",
        }}
      >
        {process === 0 && t("groups.status.justStarted")}
        {process === 1 && t("groups.status.interesting")}
        {process === 2 && t("groups.status.growing")}
        {process === 3 && t("groups.status.hot")}
        {(process === 4 || process === 5) && t("groups.status.veryHot")}
      </div>
      <div>
        {process === 0 && <StartedIcon size="20px" />}
        {process === 1 && <InterestingIcon size="20px" />}
        {process === 2 && <GrowingIcon size="20px" />}
        {process === 3 && <HotIcon size="20px" />}
        {(process === 4 || process === 5) && <VeryHotIcon size="20px" />}
      </div>
      <Process5Icon length={process} type={process < 5 ? "green" : "red"} />
    </>
  );
};
export default GroupCardProcess;
